import { NgModule } from '@angular/core';

import { USER_ACCOUNT_CORE_FEATURE, UserAccountRootModule } from '@spartacus/user/account/root';
import { USER_PROFILE_CORE_FEATURE, UserProfileRootModule } from '@spartacus/user/profile/root';
import { provideConfig } from '@spartacus/core';

@NgModule({
  declarations: [],
  imports: [
    UserAccountRootModule,
    UserProfileRootModule
  ],
  providers: [
    provideConfig({
      featureModules: {
        [USER_ACCOUNT_CORE_FEATURE]: {
          module: () => import('@spartacus/user/account/core').then((m) => m.UserAccountCoreModule),
          dependencies: [() => import('@spartacus/user/account/occ').then((m) => m.UserAccountOccModule)]
        }
      }
    }),
    provideConfig({
      featureModules: {
        [USER_PROFILE_CORE_FEATURE]: {
          module: () => import('@spartacus/user/profile/core').then((m) => m.UserProfileCoreModule),
          dependencies: [() => import('@spartacus/user/profile/occ').then((m) => m.UserProfileOccModule)]
        }
      }
    })
  ]
})
export class UserFeatureModule {}
